import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, ViewChild, inject } from '@angular/core';
import { MatMenuTrigger, MatMenu, MatMenuContent, MatMenuItem } from '@angular/material/menu';
import { ContextMenuService } from '../context-menu.service';
import { ContextMenuLineModel } from '../models/context-menu-line-model';
import { MatIcon } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-context-menu-holder',
  styleUrls: ['./context-menu-holder.component.scss'],
  templateUrl: './context-menu-holder.component.html',
  imports: [MatMenuTrigger, MatMenu, MatMenuContent, MatMenuItem, MatIcon],
})
export class ContextMenuHolderComponent {
  @ViewChild(MatMenuTrigger) private _contextMenu: MatMenuTrigger;
  public contextMenuLines: ContextMenuLineModel[];
  public contextMenuPosition = { x: '0px', y: '0px' };

  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _contextMenuService = inject(ContextMenuService);

  public constructor() {
    this._contextMenuService.openContextMenuEvent.subscribe((e: { event: MouseEvent; obj: ContextMenuLineModel[] }) => {
      this.openContextMenuHandler(e.event, e.obj);
      this._changeDetectorRef.markForCheck();
    });
    this._contextMenuService.hideContextMenuEvent.subscribe(() => {
      this.closeContextMenu();
      this._changeDetectorRef.markForCheck();
    });
  }

  public closeContextMenu() {
    this._contextMenuService.contextMenuVisibleFlag = false;
    this.contextMenuLines = [];
  }

  public contextMenuLineClickHandler(contextMenuLine: ContextMenuLineModel) {
    if (contextMenuLine.action) {
      contextMenuLine.action();
    }
  }

  @HostListener('document:click')
  public documentClickHandler(): void {
    this.closeContextMenu();
  }

  @HostListener('window:keydown.escape')
  public keydownEscape(): void {
    this.closeContextMenu();
  }

  public openContextMenuHandler(event: MouseEvent, contextMenuLines: ContextMenuLineModel[]) {
    this._contextMenuService.contextMenuVisibleFlag = true;
    this.contextMenuLines = contextMenuLines;
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this._contextMenu.menuData = { item: contextMenuLines };
    this._contextMenu.menu!.focusFirstItem('mouse');
    this._contextMenu.openMenu();
  }
}
